import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import AppContext from '../context/appContext'
import PortfolioForm from './PortfolioForm'
import { toast } from 'react-toastify'

const PortfolioEdit = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { fetchPortfolioById, updatePortfolio, deletePortfolio, uploadImage } = useContext(AppContext)
  const [initial, setInitial] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    (async () => {
      try {
        const data = await fetchPortfolioById(id)
        setInitial(data)
      } catch {
        toast.error('Failed to load portfolio')
      } finally {
        setLoading(false)
      }
    })()
  }, [id, fetchPortfolioById])

  const onSubmit = async (payload) => {
    try {
      await updatePortfolio(id, payload)
      navigate('/dashboard/portfolio')
    } catch {}
  }

  const onDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this portfolio item?')) return
    try {
      await deletePortfolio(id)
      navigate('/dashboard/portfolio')
    } catch {}
  }

  if (loading) return (
    <div className="text-center text-light py-5" style={{ backgroundColor: '#151619', minHeight: '50vh' }}>
      Loading...
    </div>
  )
  if (!initial) return null

  return (
    <div style={{ backgroundColor: '#151619', minHeight: '100vh' }}>
      <div className="container py-4">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="text-light">Edit Portfolio</h2>
          <button className="btn btn-outline-danger" onClick={onDelete}>Delete</button>
        </div>
        <PortfolioForm initial={initial} onSubmit={onSubmit} onUpload={uploadImage} />
      </div>
    </div>
  )
}

export default PortfolioEdit